export const FETCH_SERVICE_PACKAGE_RULES: "FETCH_SERVICE_PACKAGE_RULES" =
  "FETCH_SERVICE_PACKAGE_RULES"
export const FETCH_SERVICE_PACKAGE_RULES_REQUEST: "FETCH_SERVICE_PACKAGE_RULES_REQUEST" =
  "FETCH_SERVICE_PACKAGE_RULES_REQUEST"
export const FETCH_SERVICE_PACKAGE_RULES_SUCCESS: "FETCH_SERVICE_PACKAGE_RULES_SUCCESS" =
  "FETCH_SERVICE_PACKAGE_RULES_SUCCESS"
export const FETCH_SERVICE_PACKAGE_RULES_FAILURE: "FETCH_SERVICE_PACKAGE_RULES_FAILURE" =
  "FETCH_SERVICE_PACKAGE_RULES_FAILURE"

export const SERVICE_PACKAGES = Object.freeze({
  BASIC: "basic",
  PLUS: "plus",
  PREMIUM: "premium",
})

// same as BE value
export const CS_AVAILABILITY_VALUES = Object.freeze({
  EXTENDED: "extended",
  LIMITED: "limited",
})

// same as BE value
export const CALLER_PRIORITY_VALUES = Object.freeze({
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
})
